import Dropzone from 'dropzone';

/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-useless-escape */
/* eslint-disable no-plusplus */

class Utils implements MerchantosUtils {
  stringTrim = (value: string) => {
    return value.replace(new RegExp('^[\\s]+', 'g'), '').replace(new RegExp('[\\s]+$', 'g'), '');
  };

  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'url' implicitly has an 'any' type.
  openUrl = (url, target) => {
    if ($('.netpromoter').is(':visible')) {
      window.hideNetPromoter();
    }

    let newUrl = url;
    if (!window.Ashes.isPhoenixRoute(url)) {
      const phoenixRoute = window.Ashes.createRoute(url);

      if (phoenixRoute && phoenixRoute.route) {
        newUrl = phoenixRoute.route;
      }
    }

    if (window.saveOnChanges().state() === 'pending') {
      return;
    }

    if (target && window.merchantos.register.confirmForUnsavedCreditPayments()) {
      window.open(newUrl, target);
    } else {
      window.location.href = newUrl;
    }

    // cancel any pending transactions
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'partial_payments' does not exist on type... Remove this comment to see the full error message
    window.merchantos.register.partial_payments.forceCancel();
  };

  /**
   * Utility function to transform search param string into a key/value object
   *
   * @param {String} searchParams - A string containing the query parameters.
   * @return {Object} An object containing the key/value pairs of the search params.
   *
   * @example
   *
   * var searchParams = merchantos.utils.getQueryParams(window.location.search);
   */
  getQueryParams = (searchParams: string | boolean) => {
    let parsedParams = '';
    if (typeof searchParams !== 'string') {
      searchParams = '';
    }
    if (searchParams.indexOf('?') >= 0) {
      parsedParams = searchParams.split('?')[1];
    } else if (!/^\?/.test(searchParams) && searchParams.indexOf('=') >= 0) {
      // parse the params if it doesn't contain a leading '?' and still has the =
      parsedParams = searchParams;
    }

    if (!parsedParams) return {};
    return parsedParams
      .split('&')
      .map(param => param.split('='))
      .reduce((params, param) => {
        const [key, value] = param;
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        // eslint-disable-next-line no-param-reassign
        if (!params[key]) params[key] = decodeURIComponent(value);
        return params;
      }, {});
  };

  /**
   * Utility function to transform search param object into a query string.
   *
   * @param {Object} params - An object containing key/value pairs of query params.
   * @return {String} The transformed query string.
   *
   * @example
   *
   * var queryParams = { hello: 'world', test: 123 };
   * var searchParams = merchantos.utils.getQueryString(queryParams);
   */
  getQueryString = (params: { [key: string]: any }) => {
    const paramKeys = Object.keys(params);
    return `?${paramKeys.reduce((result, key, index) => {
      const value = params[key];
      // eslint-disable-next-line no-param-reassign
      result += `${key}=${encodeURIComponent(value)}`;
      if (index !== paramKeys.length - 1) {
        // eslint-disable-next-line no-param-reassign
        result += '&';
      }

      return result;
    }, '')}`;
  };

  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'form' implicitly has an 'any' type.
  loginRedirect = form => {
    if (form.action.length > 0) return true;

    const name = form.login_name.value;
    const password = form.login_password.value;

    const content_map = {} as ContentMap;
    content_map.form_name = 'login_redirect';
    content_map.name = name;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'password' does not exist on type 'Conten... Remove this comment to see the full error message
    content_map.password = password;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'form_id' does not exist on type 'Content... Remove this comment to see the full error message
    content_map.form_id = form.id;
    window.doServerCall(content_map, result => window.merchantos.utils.loginRedirectReturn(result));

    return false;
  };

  /**
   * Generate a URL to render this pannel
   *
   * First argument is a pannel object.
   * Second, optional, argument is a optional hash that will be hashed into the URL params
   *
   * */
  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'pannel' implicitly has an 'any' type.
  generatePageUrl = (pannel, ...rest) => {
    const params = {} as { [key: string]: any };
    if (pannel.current_type === 'view') {
      params.name = pannel.view.name;
      params.form_name = 'view';
      params.id = pannel.view.record_id;
      if (pannel.view.tab) {
        params.tab = pannel.view.tab;
      }
    } else if (pannel.listing) {
      params.name = pannel.listing.name;
      params.form_name = 'listing';
      // Add on saved_search parameters
      $.extend(params, pannel.listing.saved_search);
      // Supersede saved_search `__sort` and `__sort_dir` params
      // with the latest values from the listing.
      if (pannel.listing.sort) {
        params.__sort = pannel.listing.sort;
      }
      if (pannel.listing.sort_dir) {
        params.__sort_dir = pannel.listing.sort_dir;
      }
    }

    // Any optional params are mixed with the generated URL hash.
    if (window.isObjectValid(rest[0])) {
      const inject_params = rest[0];
      $.extend(params, inject_params);
    }

    return `/${window.merchantos.utils.getQueryString(params)}`;
  };

  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'result' implicitly has an 'any' type.
  loginRedirectReturn = result => {
    const form = $<HTMLFormElement>(`#${result.form_id}`)[0];

    if (!result.url) {
      form.login_name.value = '';
      form.login_password.value = '';
      window.merchantos.focus.set(form.login_name);
      return;
    }

    form.action = result.url;
    form.trigger('submit');
  };
}

window.moneycomp = function moneycomp(a, comp, b, decimals) {
  // eslint-disable-next-line no-param-reassign
  if (!decimals) decimals = 2;
  const multiplier = 10 ** decimals;
  // eslint-disable-next-line no-param-reassign
  a = Math.round(a * multiplier);
  // eslint-disable-next-line no-param-reassign
  b = Math.round(b * multiplier);
  switch (comp) {
    case '>':
      return a > b;
    case '>=':
      return a >= b;
    case '<':
      return a < b;
    case '<=':
      return a <= b;
    case '!=':
      return a !== b;
    case '==':
      return a === b;
    default: {
      return null;
    }
  }
};

window.sleep = function sleep(ms) {
  const dt = new Date();
  dt.setTime(dt.getTime() + ms);
  while (new Date().getTime() < dt.getTime());
};

/**
 * Switches view to a content pannel
 *
 * @param {String} type
 * @param {String} name
 * @param {String|Object} [init_search|id]
 * @param {String} [tab]
 * @returns {$.Deferred}
 */
window.navigateToContent = function navigateToContent(type, name, ...rest) {
  $('body,html').scrollTop(0);

  if ($('.netpromoter').is(':visible')) {
    window.hideNetPromoter();
  }

  // Optional attribute - position 3 (can be init_search or id)
  let search_params;
  const init_search = {};
  let id;
  // Optional attribute - position 4
  let tab;
  // Optional attribute - position 5
  let context;

  const loading = $('#loading');
  loading.fadeIn('fast');

  if (window.isObjectValid(rest[0])) {
    search_params = rest[0];
  } else if (window.isString(rest[0]) || window.isNumber(rest[0])) {
    id = rest[0];
  }

  // Used by register and workorder views
  if (window.isString(rest[1])) {
    tab = rest[1];
  }

  if (typeof rest[2] === 'object' && rest[2] !== null) {
    context = rest[2];
  }

  // build the page url for the new content
  let href = `/?form_name=${type}`;
  if (name) {
    href += `&name=${name}`;
  }
  if (id) {
    href += `&id=${id}`;
  }
  if (tab) {
    href += `&tab=${tab}`;
  }

  if (Array.isArray(search_params) && search_params.length) {
    $.each(search_params, (_, val) => {
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      init_search[val[0]] = val[1];
      href += `&${val[0]}=${val[1]}`;
    });
  }

  // if we have loaded more than 20 new content items then do a hard page load for new content
  // this will help keep memory more tidy
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'dynamic_content_load_count' does not exi... Remove this comment to see the full error message
  if (!window.dynamic_content_load_count) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'dynamic_content_load_count' does not exi... Remove this comment to see the full error message
    window.dynamic_content_load_count = 0;
  }

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'dynamic_content_load_count' does not exi... Remove this comment to see the full error message
  window.dynamic_content_load_count++;
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'dynamic_content_load_count' does not exi... Remove this comment to see the full error message
  if (window.dynamic_content_load_count > 20) {
    window.merchantos.utils.openUrl(href);
  }

  // This is basically our static Router.
  // It's in a weird place
  // @TODO - Let's make this suck less.
  // open the new content
  if (type === 'listing') {
    return window.OpenListing('listing', name, init_search, tab);
  }
  if (type === 'view') {
    // @ts-expect-error FIXME: Type 'number' is not assignable to type 'string | undefined'
    return window.newView('view', name, id, tab, context);
  }
  return $.Deferred()
    .resolve()
    .promise();
};

window.saveBeforeClose = function saveBeforeClose() {
  // React pages will validate its dirty form fields
  // not using gui_def generic functions
  if (window.isReactPage) return;

  window.closing = true;
  if (window.hasUnsavedChanges()) {
    let prop;
    // eslint-disable-next-line
    for (prop in window.do_saves) {
      // eslint-disable-next-line no-alert
      if (!window.confirm('Save changes before exiting?')) return;
      break;
    }
    window.saveChanges();
  }
};

window.hasUnsavedChanges = function hasUnsavedChanges() {
  let hasChanges = false;

  if (window.isObjectValid(window.do_saves)) {
    hasChanges = Object.keys(window.do_saves).length > 0;
  }

  return hasChanges;
};

window.saveChanges = function saveChanges() {
  const savePromises = [];

  if (window.hasUnsavedChanges()) {
    // eslint-disable-next-line
    for (const prop in window.do_saves) {
      // @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
      savePromises.push(window.saveRecord(window.do_saves[prop]));
    }
  }

  return $.when(...savePromises);
};

window.isObjectValid = function isObjectValid(obj) {
  if (typeof obj === 'object' && obj !== null) return true;
  return false;
};

window.isString = function isString(str) {
  if (typeof str === 'string') return true;
  return false;
};

window.isNumber = function isNumber(number) {
  if (typeof number === 'number') return true;
  return false;
};

window.isURL = function isURL(url) {
  if (
    url.match(
      /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/
    )
  ) {
    return true;
  }
  return false;
};

window.isEmail = function isEmail(email) {
  if (email.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i)) {
    return true;
  }
  return false;
};

window.objectPropertyCount = function objectPropertyCount(obj) {
  if (!window.isObjectValid(obj)) return 0;
  let count = 0;
  // eslint-disable-next-line
  for (const _ in obj) {
    // eslint-disable-next-line no-plusplus
    count++;
  }
  return count;
};

window.toJsonString = function toJsonString(arg) {
  return JSON.stringify(arg);
};

// Take a JSON object and return a string as url parameters
// Note: Only deals with simple objects (key-pair)
window.jsonToUrlParams = function jsonToUrlParams(json) {
  // @ts-expect-error ts-migrate(7034) FIXME: Variable 'params' implicitly has type 'any[]' in s... Remove this comment to see the full error message
  const params = [];

  $.each(json, (key, value) => params.push(`${key}=${encodeURIComponent(value)}`));

  // @ts-expect-error ts-migrate(7005) FIXME: Variable 'params' implicitly has an 'any[]' type.
  return params.join('&');
};

// Clean any empty attributes out of a JSON object.
window.compactObj = function compactObj(obj) {
  // eslint-disable-next-line
  for (const key in obj) {
    if (!obj[key]) {
      // eslint-disable-next-line no-param-reassign
      delete obj[key];
    }
  }

  return obj;
};

// @ts-expect-error ts-migrate(2322) FIXME: Type '<T extends string | HTMLElement>(e: T) => T ... Remove this comment to see the full error message
window.xGetElementById = function xGetElementById(e) {
  if (typeof e === 'object' && e !== null) {
    return e;
  }
  return window.singleElementById(e);
};

// @ts-expect-error ts-migrate(2322) FIXME: Type '<T extends string | HTMLElement>(e: T) => HT... Remove this comment to see the full error message
// eslint-disable-next-line consistent-return
window.singleElementById = function singleElementById(e) {
  if (typeof e === 'object' && e !== null) {
    return e;
  }
  if (e !== undefined) {
    return $(`#${String(e).replace(/\./g, '\\.')}`)[0];
  }
};

window.custGetElementsByClassName = function custGetElementsByClassName(
  className,
  parentNode,
  nodeType
) {
  let selector = `.${className}`;
  if (typeof nodeType === 'string' && nodeType !== null) selector = nodeType + selector;

  if (typeof parentNode === 'object' && parentNode !== null) return $(parentNode).find(selector);
  return $(selector);
};

window.getObjectClass = function getObjectClass(obj) {
  if (obj && obj.constructor && obj.constructor.toString) {
    const arr = obj.constructor.toString().match(/function\s*(\w+)/);
    return arr && arr.length === 2 ? arr[1] : undefined;
  }
  return undefined;
};

// @ts-expect-error ts-migrate(2322) FIXME: Type '<T>(what: T) => {}' is not assignable to typ... Remove this comment to see the full error message
window.cloneObject = function cloneObject(what) {
  if (typeof what !== 'object') {
    return what;
  }
  let ret;
  // eslint-disable-next-line @typescript-eslint/ban-types
  if (window.getObjectClass((what as unknown) as Record<string, string>) === 'Array') ret = [];
  else ret = {};
  // eslint-disable-next-line
  for (const i in what) {
    try {
      if (typeof what[i] === 'object') {
        // @ts-expect-error ts-migrate(2536) FIXME: Type 'Extract<keyof T, string>' cannot be used to ... Remove this comment to see the full error message
        // eslint-disable-next-line new-cap
        ret[i] = new window.cloneObject(what[i]);
        // @ts-expect-error ts-migrate(2536) FIXME: Type 'Extract<keyof T, string>' cannot be used to ... Remove this comment to see the full error message
      } else ret[i] = what[i];
    } catch (e) {
      // @ts-expect-error ts-migrate(2536) FIXME: Type 'Extract<keyof T, string>' cannot be used to ... Remove this comment to see the full error message
      ret[i] = what[i];
    }
  }
  return ret;
};

window.toggleDisplay = function toggleDisplay(id) {
  const ele = window.xGetElementById(id);
  if (!ele) return;

  if (ele.style.display === 'none') ele.style.display = '';
  else ele.style.display = 'none';
};

window.toggleDisplayAndFocus = function toggleDisplayAndFocus(id) {
  window.toggleDisplay(id);
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
  window.setAutoFocus(id);
};

window.getRealPannelID = function getRealPannelID(pannel_id) {
  const pannel = window.xGetElementById(pannel_id);
  if (!pannel) return pannel_id;
  if (pannel.parent_id) return pannel.parent_id;
  return pannel.id;
};

// @ts-expect-error ts-migrate(2322) FIXME: Type '(pannel_id: PanelId) => false | HTMLElement ... Remove this comment to see the full error message
window.getRealPannel = function getRealPannel(pannel_id) {
  const pannel = window.xGetElementById(pannel_id);
  if (!pannel) return false;
  if (pannel.parent_id) return window.xGetElementById(pannel.parent_id);
  return pannel;
};

// Subtract one array from another and return the result
window.arraySubtract = function arraySubtract(subject, subtract) {
  if (subtract.length > 0 && subject.length > 0) {
    $(subtract).each((_key, value) => {
      if ($.inArray(value, subject) > -1) {
        subject.splice($.inArray(value, subject), 1);
      }
    });
  }

  return subject;
};

// eslint-disable-next-line no-extend-native
String.prototype.toCapitalize = function capititalizeString() {
  return this.toLowerCase().replace(/^.|\s\S/g, a => a.toUpperCase());
};

// Limit a string to maxSize and insert an ellipsis in the middle
// eslint-disable-next-line no-extend-native
String.prototype.shorten =
  String.prototype.shorten ||
  function shortenString(maxSize) {
    // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
    if (this.length > maxSize) {
      const charsFromFront = maxSize / 2;
      const charsFromEnd = maxSize - charsFromFront - (maxSize % 2 !== 0 ? 0 : 1); // account for ellipsis

      // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
      return `${this.substr(0, charsFromFront)}...${this.substr(
        // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        this.length - charsFromEnd,
        charsFromEnd
      )}`;
    }
    // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
    return this;
  };

/**
 * @deprecated Most likely. Seems very unlikely this is still in use based on the document methods being called
 */
window.synthesizeTouchEventOnElement = function synthesizeTouchEventOnElement(element) {
  if (element) {
    // synthesize a touch event
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'createTouch' does not exist on type 'Doc... Remove this comment to see the full error message
    const touch = document.createTouch(window, element, new Date().getTime(), 0, 0, 0, 0);

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'createTouchList' does not exist on type ... Remove this comment to see the full error message
    const touches = document.createTouchList(touch);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'createTouchList' does not exist on type ... Remove this comment to see the full error message
    const targetTouches = document.createTouchList(touch);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'createTouchList' does not exist on type ... Remove this comment to see the full error message
    const changedTouches = document.createTouchList(touch);

    const event = document.createEvent('TouchEvent');
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'initTouchEvent' does not exist on type '... Remove this comment to see the full error message
    event.initTouchEvent(
      'touchend',
      true,
      true,
      window,
      null,
      0,
      0,
      0,
      0,
      false,
      false,
      false,
      false,
      touches,
      targetTouches,
      changedTouches,
      1,
      0
    );

    element.dispatchEvent(event);
  }
};

/**
 * TODO: Eventually remove this when we're done with dropzone.
 * This is a hack that we used to have hardcoded when the library was in the /lib folder
 */
window.blockDropzoneFilesizeTranslation = function blockDropzoneFilesizeTranslation() {
  if (typeof Dropzone === 'undefined') return;
  // Add a `notranslate` class to the filesize method
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'filesize' does not exist on type 'Dropzo... Remove this comment to see the full error message
  // eslint-disable-next-line no-undef
  Dropzone.prototype.filesize = size => {
    let string;
    if (size >= 100000000000) {
      // operator-assignment no-param-reassign
      // eslint-disable-next-line
      size = size / 100000000000;
      string = 'TB';
    } else if (size >= 100000000) {
      // operator-assignment no-param-reassign
      // eslint-disable-next-line
      size = size / 100000000;
      string = 'GB';
    } else if (size >= 100000) {
      // operator-assignment no-param-reassign
      // eslint-disable-next-line
      size = size / 100000;
      string = 'MB';
    } else if (size >= 100) {
      // operator-assignment no-param-reassign
      // eslint-disable-next-line
      size = size / 100;
      string = 'KB';
    } else {
      // operator-assignment no-param-reassign
      // eslint-disable-next-line
      size = size * 10;
      string = 'b';
    }
    return `<strong notranslate>${Math.round(size) / 10}</strong> ${string}`;
  };
};

window.merchantos.utils = new Utils();
